import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import countries from '../../arrays/countries.json';
import languages from '../../arrays/languages.json';
import { storage } from '../../firebase';
import { getDownloadURL, uploadBytes, ref as sRef, uploadBytesResumable } from 'firebase/storage';
import axios from 'axios';
import emails from '../../arrays/emails.json';
import 'react-datepicker/dist/react-datepicker.css';
import { enGB } from 'date-fns/locale';
import { createRelease } from '../../api/releases';
import { createArtist } from '../../api/artists';
import { getUser } from '../../api/user';
import { getPlatforms } from '../../api/platforms';
import { getGenres } from '../../api/genres';

// Import shared components
import TabNavigation from '../shared/TabNavigation';
import ReleaseInfoTab from './ReleaseInfoTab';
import TrackInfoTab from './TrackInfoTab';
import DistributionTab from './DistributionTab';
import ArtistModal from '../shared/ArtistModal';
import EditTrackModal from '../shared/EditTrackModal';

// Add styles for loading overlay
const styles = `
  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }

  .loading-spinner {
    text-align: center;
  }

  .loading-spinner .spinner-border {
    width: 3rem;
    height: 3rem;
  }

  .loading-spinner p {
    font-size: 1.1rem;
    color: #666;
  }
`;

const AddRelease = () => {
  const [tab, setTab] = useState(1);
  const [activeRadio, setActiveRadio] = useState(1);
  const [activeRadio1, setActiveRadio1] = useState(1);

  const [tracks, setTracks] = useState([]);
  const [artists1, setArtists1] = useState([]);
  const [artists2, setArtists2] = useState([]);
  const [artistRole, setArtistRole] = useState('Featuring');
  const [artistName, setArtistName] = useState('Name');

  const [isrcDisabled, setIsrcDisabled] = useState(false);
  const [upcDisabled, setUpcDisabled] = useState(false);

  const [genres, setGenres] = useState([]);
  const [genresList, setGenresList] = useState([]);
  const [primaryGenresList, setPrimaryGenresList] = useState([]);
  const [secondaryGenresList, setSecondaryGenresList] = useState([]);
  const [genre, setGenre] = useState('');
  const [primaryGenre, setPrimaryGenre] = useState('');
  const [secondaryGenre, setSecondaryGenre] = useState('');

  const [editTitle, setEditTitle] = useState('');
  const [editId, setEditId] = useState('');
  const [editTrackIndex, setEditTrackIndex] = useState(0);
  
  // Filter functions
  const filterGenres = (e) => {
    setGenre(e.target.value);
    setGenresList(genres.filter(item => item.toLowerCase().includes(e.target.value.toLowerCase())));
  };
  
  const filterPrimaryGenres = (e) => {
    setPrimaryGenre(e.target.value);
    setPrimaryGenresList(genres.filter(item => item.toLowerCase().includes(e.target.value.toLowerCase())));
  };
  
  const filterSecondaryGenres = (e) => {
    setSecondaryGenre(e.target.value);
    setSecondaryGenresList(genres.filter(item => item.toLowerCase().includes(e.target.value.toLowerCase())));
  };

  const [labels, setLabels] = useState([]);
  const [labelsList, setLabelsList] = useState(labels);
  const [label, setLabel] = useState('');

  const filterLabels = (e) => {
    setLabel(e.target.value);
    setLabelsList(labels.filter(item => item.name.toLowerCase().includes(e.target.value.toLowerCase())));
  };

  // Artist handling
  const removeArtist1 = (index) => {
    const updatedData = [...artists1];
    updatedData.splice(index, 1);
    setArtists1(updatedData);
  };
  
  const removeArtist2 = (index) => {
    const updatedData = [...artists2];
    updatedData.splice(index, 1);
    setArtists2(updatedData);
  };
  
  const formatDuration = (durationInSeconds) => {
    const minutes = Math.floor(durationInSeconds / 60);
    const seconds = Math.floor(durationInSeconds % 60);
    const formattedDuration = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    return formattedDuration;
  };

  // Upload handling
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadText, setUploadText] = useState('Choose file...');
  const jsmediatags = window.jsmediatags;

  const uploadTrack = async (file) => {
    const storageRef = sRef(storage, `tracks/${file.name}`);
    
    try {
      const uploadTask = uploadBytesResumable(storageRef, file);
      
      uploadTask.on('state_changed', (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setUploadProgress(progress);
      });
    
      await uploadTask;
      const downloadURL = await getDownloadURL(storageRef);
      return downloadURL;
    
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };
  
  const [loader, setLoader] = useState(false);

  const readFile = (event) => {
    setUploadText('Please wait...');
    const songs = event.target.files;
    const promises = [];
    
    for (let i = 0; i < songs.length; i++) {
      const song = songs[i];
      const promise = uploadTrack(song).then((result) => {
        return new Promise((resolve) => {
          setTimeout(() => {
            var uniqueId = Math.random().toString(36).substr(2, 9);
            const audio = new Audio(URL.createObjectURL(song));

            audio.onloadedmetadata = () => {
              jsmediatags.read(song, {
                onSuccess: function (tag) {
                  setTracks((oldTracks) => [
                    ...oldTracks,
                    {
                      title: tag.tags.title || song.name,
                      filename: song.name,
                      id: uniqueId,
                      artists: artists2,
                      genre: genre,
                      clipStart: clipStart,
                      isrc: isrc,
                      copyright: copyright,
                      trackLanguage: trackLanguage,
                      explicit: explicit,
                      lyrics: lyrics,
                      duration: formatDuration(audio.duration),
                      file: result,
                    },
                  ]);
                  resolve();
                },
                onError: function (error) {
                  console.log(error);
                  setTracks((oldTracks) => [
                    ...oldTracks,
                    {
                      title: song.name,
                      filename: song.name,
                      id: uniqueId,
                      artists: [],
                      genre: genre,
                      clipStart: clipStart,
                      isrc: isrc,
                      copyright: copyright,
                      trackLanguage: trackLanguage,
                      explicit: explicit,
                      lyrics: lyrics,
                      duration: formatDuration(audio.duration),
                      file: result,
                    },
                  ]);
                  resolve();
                },
              });
            };
          }, 500);
        });
      });
    
      promises.push(promise);
    }
    
    Promise.all(promises)
      .then(() => {
        setUploadText('Choose file...');
      })
      .catch((error) => {
        console.error('Error processing tracks:', error);
        setUploadText('Choose file...');
      });
  };
  
  const removeTrack = (index) => {
    const updatedData = [...tracks];
    updatedData.splice(index, 1);
    setTracks(updatedData);
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
  
    const reorderedItems = Array.from(tracks);
    const [reorderedItem] = reorderedItems.splice(result.source.index, 1);
    reorderedItems.splice(result.destination.index, 0, reorderedItem);
  
    setTracks(reorderedItems);
  };
  
  const [checkedCountries, setCheckedCountries] = useState(['Worldwide']);

  const handleCheckCountry = (country, e) => {
    if (e.target.checked) {
      setCheckedCountries([...checkedCountries, country]);
    } else {
      setCheckedCountries(checkedCountries.filter((c) => c !== country));
    }
  };

  const updateTrack = () => {
    const updatedTracks = tracks.map(item => {
      if (item.id === editId) {
        if (isrcDisabled) {
          return { 
            ...item,
            title: editTitle,
            artists: artists2,
            genre: genre,
            clipStart: clipStart,
            isrc: isrc,
            copyright: copyright,
            trackLanguage: trackLanguage,
            explicit: explicit,
            lyrics: lyrics,
            autoISRC: true
          };
        } else {
          return { 
            ...item,
            title: editTitle,
            artists: artists2,
            genre: genre,
            clipStart: clipStart,
            isrc: isrc,
            copyright: copyright,
            trackLanguage: trackLanguage,
            explicit: explicit,
            lyrics: lyrics,
            autoISRC: false
          };
        }
      }
      return item;
    });
  
    setIsrcDisabled(false);
    setTracks(updatedTracks);
  };

  // Backend related state
  const [releases, setReleases] = useState([]);
  const [platforms, setPlatforms] = useState([]);
  const [drafts, setDrafts] = useState([]);
  const [artists, setArtists] = useState([]);
  const [username, setUsername] = useState('');
  const [adminsEmails, setAdminsEmails] = useState([]);

  // Release form state
  const [title, setTitle] = useState('');
  const [upc, setUpc] = useState('');
  const [originalDate, setOriginalDate] = useState(new Date());
  const [digitalDate, setDigitalDate] = useState(new Date());
  const [years, setYears] = useState([]);
  const [copyrightYear, setCopyrightYear] = useState('');
  const [copyrightLine, setCopyrightLine] = useState('');
  const [publishingYear, setPublishingYear] = useState('');
  const [publishingLine, setPublishingLine] = useState('');
  const [clipStart, setClipStart] = useState('');
  const [isrc, setIsrc] = useState('');
  const [copyright, setCopyright] = useState('');
  const [trackLanguage, setTrackLanguage] = useState('Instrumental');
  const [distribution, setDistribution] = useState('Content ID Only');
  const [explicit, setExplicit] = useState('Yes');
  const [checkedAll, setCheckedAll] = useState(false);
  const [counter, setCounter] = useState('');
  const [prefix, setPrefix] = useState('');
  const [upcs, setUpcs] = useState([]);
  const [lyrics, setLyrics] = useState('');
  const [newReleasesItems, setNewReleasesItems] = useState([]);

  // References
  const successBtn = useRef();
  const warningPopupBtn = useRef();
  const draftSuccess = useRef();
  const uid = localStorage.getItem('uid');
  const savedRelease = localStorage.getItem('release');
  const fileInputRef = useRef(null);

  // UI state
  const [imgPreview, setImgPreview] = useState(false);
  const [imgSrc, setImgSrc] = useState('');
  const [uploadLabel, setUploadLabel] = useState('Choose file');
  const [saveMsg, setSaveMsg] = useState('Save');
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isAddingArtist, setIsAddingArtist] = useState(false);
  const [autoArtists, setAutoArtists] = useState(false);
  const [autoGenre, setAutoGenre] = useState(false);
  const [autoLanguage, setAutoLanguage] = useState(false);

  // Artist form state
  const [name, setName] = useState('');
  const [website, setWebsite] = useState('');
  const [facebook, setFacebook] = useState('');
  const [twitter, setTwitter] = useState('');
  const [instagram, setInstagram] = useState('');
  const [youtube, setYoutube] = useState('');
  const [spotify, setSpotify] = useState('');
  const [apple, setApple] = useState('');
  const [deezer, setDeezer] = useState('');
  const [soundCloud, setSoundCloud] = useState('');

  const handleEditTrack = (track, index) => {
    setEditTitle(track.title);
    setEditId(track.id);
    setArtists2(track.artists || []);
    setGenre(track.genre);
    setIsrc(track.isrc);
    setCopyright(track.copyright);
    setTrackLanguage(track.trackLanguage);
    setClipStart(track.clipStart);
    setAutoGenre(false);
    setAutoArtists(false);
    setEditTrackIndex(index);
    track.trackLanguage !== 'Instrumental' ? setActiveRadio1(2) : setActiveRadio1(1);
  };

  const initialValues = (item) => {
    setTitle(item.title);
    setArtists1(item.artists || []);
    setUpc(item.upc);
    setPrimaryGenre(item.primaryGenre);
    setSecondaryGenre(item.secondaryGenre);
    setLabel(item.label);
    setOriginalDate(new Date(item.originalDate));
    setDigitalDate(new Date(item.digitalDate));
    setCopyrightYear(item.copyrightYear);
    setCopyrightLine(item.copyrightLine);
    setPublishingYear(item.publishingYear);
    setPublishingLine(item.publishingLine);
    setCheckedCountries(item.countries);
    setTracks(item.tracks || []);
    setDistribution(item.distribution);
    setImgSrc(item.artwork);
    item.artwork && setImgPreview(true);
    item.artwork && setUploadLabel('Replace file');
  };

  useEffect(() => {
    const usersFunc = async () => {
      const usersInfo = await getUser(uid);
      console.log(usersInfo);
      setReleases(usersInfo.releases);
      setArtists(usersInfo.artists);
      setDrafts(usersInfo.drafts || {});
      setLabels(usersInfo.labels);
      setLabelsList(usersInfo.labels);
    };
  
    const platformsFunc = async () => {
      const platformInfo = await getPlatforms();
      const mappedInfo = platformInfo.platforms.map(platform => {
        return {
          ...platform,
          checked: false
        };
      });
      setPlatforms(mappedInfo);
    };
   
    const genresFunc = async () => {
      const genresInfo = await getGenres();
      const genresArray = genresInfo.genres.map(genre => genre.name);
      setGenres(genresArray);
      setGenresList(genresArray);
      setPrimaryGenresList(genresArray);
      setSecondaryGenresList(genresArray);
    };
   
    const parallel = [genresFunc(), platformsFunc(), usersFunc()];
    Promise.all(parallel);

    if (savedRelease !== null) {
      initialValues(JSON.parse(savedRelease));
    }

    fetchYear();
  }, []);

  const fetchYear = async () => {
    try {
      const year = new Date().getFullYear();
      setCopyrightYear(year);
      setPublishingYear(year);

      const yearsArray = [];

      for (let currentYear = year; currentYear >= 1990; currentYear--) {
        yearsArray.push(currentYear);
      }

      setYears(yearsArray);
    } catch (err) {
      setError(err.message);
    }
  };

  const handleSort = (platformsArr) => {
    const sortedData = [...platformsArr].sort((a, b) => {
      return a.title.localeCompare(b.title);
    });

    return sortedData;
  };

  const generateReleaseId = () => {
    let draftId = 0;
    drafts.forEach(draft => {
      if (draft.id.includes('Draft#')) {
        const [drTitle, drId] = draft.id.split('#');
        draftId = Math.max(draftId, drId * 1);
      }
    });
    return `Draft #${draftId + 1}`;
  };
  
  const handleSave = () => {
    setIsSaving(true);
    setSaveMsg('Saving...');
    
    const release = {
      id: title.trim() === '' ? generateReleaseId() : title,
      title: title,
      artists: artists1,
      upc: upc,
      primaryGenre: primaryGenre,
      secondaryGenre: secondaryGenre,
      label: label,
      originalDate: originalDate,
      digitalDate: digitalDate,
      copyrightYear: copyrightYear,
      copyrightLine: copyrightLine,
      publishingYear: publishingYear,
      publishingLine: publishingLine,
      countries: checkedCountries,
      tracks: tracks,
      distribution: distribution,
      status: "Processing",
      artwork: imgSrc,
      lastSaved: new Date().toISOString()
    };
    
    // Save to localStorage with a unique key including the user ID
    const localDraftKey = `release_draft_${uid}`;
    
    // Get existing drafts or initialize empty array
    const existingDrafts = JSON.parse(localStorage.getItem(localDraftKey) || '[]');
    
    // Check if this draft already exists (by id)
    const existingDraftIndex = existingDrafts.findIndex(draft => draft.id === release.id);
    
    if (existingDraftIndex !== -1) {
      // Update existing draft
      existingDrafts[existingDraftIndex] = release;
    } else {
      // Add new draft
      existingDrafts.push(release);
    }
    
    // Save back to localStorage
    localStorage.setItem(localDraftKey, JSON.stringify(existingDrafts));
    
    // Set current release in localStorage to easily resume editing
    localStorage.setItem('release', JSON.stringify(release));
    
    // Reset the button after a short delay to simulate saving
    setTimeout(() => {
      draftSuccess.current.click();
      setIsSaving(false);
      setSaveMsg('Save');
    }, 500);
  };

  const handleError = (errorMsg) => {
    setError(errorMsg);
    setTimeout(() => {
      setError('');
    }, 5000);
  };

  const hasArtistsForAllRoles = (artists, roles) => {
    const artistRoles = artists.map(artist => artist.role);
    let missingRoles = {};

    if (artistRoles.includes("Composer & Lyricist")) {
      roles = roles.filter(role => role !== "Composer" && role !== "Lyricist");
    }

    roles.forEach(role => {
      const foundRole = artistRoles.find(item => item === role);
      if (!foundRole) missingRoles[role] = true;
    });

    return missingRoles;
  };
    
  // Roles to check for
  const rolesToCheck = ['Composer', 'Lyricist', 'Primary Artist'];

  const handleCheck = (index) => {
    let newPlatforms = [...platforms];
    if (newPlatforms[index].checked === true) {
      newPlatforms[index].checked = false;
      setPlatforms(newPlatforms);
    } else {
      newPlatforms[index].checked = true;
      setPlatforms(newPlatforms);
    }
  };

  const checkAll = () => {
    setCheckedAll(!checkedAll);
    let newPlatforms = [...platforms];
    for (let i = 0; i < newPlatforms.length; i++) {
      const element = newPlatforms[i];
      element.checked = !checkedAll;
    }
    setPlatforms(newPlatforms);
  };

  const updatePlatforms = () => {
    let newPlatforms = [];
    let count = 0;
    platforms.forEach(platform => {
      if (platform.checked === true) {
        newPlatforms.push({
          ...platform,
          status: 'Never Distributed',
          platformId: platform.platform_id || platform.platformId,
          checked: true,
          link: '',
        });
      }
      count++;
    });
    if (count === platforms.length) {
      return newPlatforms;
    }
  };

  const autoISRC = () => {
    const updatedTracks = [];
    let count = 0;
    for (let i = 0; i < tracks.length; i++) {
      const {id, ...track} = tracks[i];
      if (track.autoISRC === true) {
        updatedTracks.push({ 
          ...track,
          isrc: '',
          autoISRC: true
        });
        count++;
      } else {
        updatedTracks.push({ 
          ...track,
          autoISRC: false
        });
      }
    }

    return {updatedTracks, count};
  };

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    return `${year}/${month}/${day}`;
  };
  
  const handleAddRelease = async () => {
    

    const updatedTracks = autoISRC();
    const release = {
      customID: '',
      title: title,
      artists: artists1,
      upc: upcDisabled ? '' : upc,
      primaryGenre: primaryGenre,
      secondaryGenre: secondaryGenre,
      label: label,
      originalDate: originalDate.toISOString(),
      digitalDate: digitalDate.toISOString(),
      copyrightYear: copyrightYear,
      copyrightLine: copyrightLine,
      publishingYear: publishingYear,
      publishingLine: publishingLine,
      countries: checkedCountries,
      tracks: updatedTracks.updatedTracks,
      distribution: distribution,
      status: "Processing",
      artwork: imgSrc,
      platforms: updatePlatforms(),
      distributions: updatePlatforms(),
      autoUPC: upcDisabled
    };
    
    const hasAllRolesInReleaseArtists = hasArtistsForAllRoles(release.artists, rolesToCheck);
    const hasAllRolesInTracks = release.tracks.every(track => hasArtistsForAllRoles(track.artists || [], rolesToCheck));

    let missingArtistsMessage = [];
    if (Object.keys(hasAllRolesInReleaseArtists).length !== 0) {
      const missingReleaseArtists = Object.keys(hasAllRolesInReleaseArtists).join(', ');
      missingArtistsMessage.push(`The release is missing the <i>${missingReleaseArtists}</i>`);
    }
    
    release.tracks.forEach((track, index) => {
      const missingArtists = hasArtistsForAllRoles(track.artists || [], rolesToCheck);
      if (Object.keys(missingArtists).length !== 0) {
        const missingTrackArtists = Object.keys(missingArtists).join(', ');
        missingArtistsMessage.push(`The track ${index + 1} is missing the <i>${missingTrackArtists}</i>`);
      }
    });
    
    if (missingArtistsMessage.length === 0) {
      const missingISRCs = tracks.find(item => item.isrc === '' && item.autoISRC === false);
      const missingTrackTitle = tracks.find(item => item.title.trim() === '');
      const missingTrackGenre = tracks.find(item => item.genre === '');
      
      if (imgPreview === false) {
        handleError('Artwork missing');
      } else if (title.trim() === '') {
        handleError('Title missing');
      } else if (tracks.length === 0) {
        handleError('Tracks missing');
      } else if (primaryGenre === '') {
        handleError('Missing primary genre');
      } else if (secondaryGenre === '') {
        handleError('Missing secondary genre');
      } else if (upc === '' && upcDisabled === false) {
        handleError('Missing UPC');
      } else if (missingISRCs) {
        handleError('Missing ISRCs');
      } else if (missingTrackTitle) {
        handleError('Missing track\'s title');
      } else if (missingTrackGenre) {
        handleError('Missing track\'s genre');
      } else {
        const primaryArtists = release.artists.filter(artist => artist.role === 'Primary Artist');

        if (primaryArtists.length >= 4) {
          setNewReleasesItems([release]);
          warningPopupBtn.current.click();
          setIsSubmitting(false);
          setShowLoadingOverlay(false);
        } else {
          try {
            setIsSubmitting(true);
            setShowLoadingOverlay(true);
            setError('');
            const response = await createRelease({
              ...release,
              userProfileId: uid
            });
            
            // Remove the draft from local storage if successful
            const localDraftKey = `release_draft_${uid}`;
            const localDrafts = JSON.parse(localStorage.getItem(localDraftKey) || '[]');
            
            // Find any draft with this title/id and remove it
            const draftToRemove = localDrafts.findIndex(
              draft => draft.title === title || draft.id === (title.trim() === '' ? generateReleaseId() : title)
            );
            
            if (draftToRemove !== -1) {
              localDrafts.splice(draftToRemove, 1);
              localStorage.setItem(localDraftKey, JSON.stringify(localDrafts));
            }
            
            // Clean up the current release in localStorage
            localStorage.removeItem('release');
            
            setIsSubmitting(false);
            setShowLoadingOverlay(false);
            successBtn.current.click();
          } catch (error) {
            setSubmitError('Failed to create release: ' + error.message);
            setShowErrorModal(true);
          } finally {
            setIsSubmitting(false);
            setShowLoadingOverlay(false);
          }
        }
      }
    } else {
      const artistsErrorMessage = missingArtistsMessage.join('<br />');
      handleError(artistsErrorMessage);
      setIsSubmitting(false);
      setShowLoadingOverlay(false);
    }
  };

  const submitRelease = async (newReleases) => {
    setIsSubmitting(true);
    setShowLoadingOverlay(true);
    try {
      if (adminsEmails.length > 0) {
        const emailTemplate = emails[5];
        const subject = emailTemplate.subject;
        const content = emailTemplate.content.replace(/\*\|user_name\|\*/g, username);
        await axios.post('https://bne-backend.vercel.app/submitEmail', {
          email: adminsEmails,
          subject,
          content
        });
      }
      await createRelease(newReleases);
      
      // Remove the draft from local storage
      const localDraftKey = `release_draft_${uid}`;
      const localDrafts = JSON.parse(localStorage.getItem(localDraftKey) || '[]');
      const filteredDrafts = localDrafts.filter(draft => draft.id !== newReleases.id);
      localStorage.setItem(localDraftKey, JSON.stringify(filteredDrafts));
      
      successBtn.current.click();
      localStorage.removeItem('release');
    } catch (error) {
      setSubmitError('Failed to submit release: ' + error.message);
      setShowErrorModal(true);
    } finally {
      setIsSubmitting(false);
      setShowLoadingOverlay(false);
    }
  };

  // Artist form handling
  const clearArtistForm = () => {
    setName('');
    setWebsite('');
    setFacebook('');
    setTwitter('');
    setInstagram('');
    setYoutube('');
    setSpotify('');
    setApple('');
    setDeezer('');
    setSoundCloud('');
  };

  const handleAddArtist = async () => {
    setIsAddingArtist(true);
    const userId = localStorage.getItem('uid');
    const artist = {
      name,
      website,
      facebook,
      twitter,
      instagram,
      youtube,
      spotify,
      apple,
      deezer,
      soundCloud
    };
    try {
      // Add artist to backend
      const created = await createArtist(userId, artist);
      // Update state with returned artist if available
      const newArtists = [...artists, created.artist || artist];
      setArtists(newArtists);
      clearArtistForm();
      // Optionally show success notification here
    } catch (error) {
      // Optionally show error notification here
      console.error('Failed to add artist:', error);
    } finally {
      setIsAddingArtist(false);
    }
  };

  // Image handling
  const checkImg = async (event) => {
    setUploadLabel('Please Wait...');
    const file = event.target.files[0];
    const fileType = file.name.split('.').pop().toLowerCase();
    const fileSize = file.size / 1000000;
    const reader = new FileReader();

    reader.onload = (e) => {
      const img = new Image();
  
      img.onload = () => {
        const resolution = {
          width: img.width,
          height: img.height,
        };
  
        if (resolution.width === resolution.height && resolution.width <= 3000 && resolution.width >= 1500) {
          uploadArtwork(file);
        } else {
          setUploadLabel('Invalid Resolution');
          setTimeout(() => {
            setUploadLabel('Choose File...');
          }, 2000);
        }
      };
  
      img.src = e.target.result;
    };

    if (fileSize < 10) {
      if (fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg') {
        reader.readAsDataURL(file);      
      } else {
        setUploadLabel('Invalid Format');
        setTimeout(() => {
          setUploadLabel('Choose File...');
        }, 2000);
      }
    } else {
      setUploadLabel('Invalid Size');
      setTimeout(() => {
        setUploadLabel('Choose File...');
      }, 2000);
    }
  };

  const uploadArtwork = async (file) => {
    const storageRef = sRef(storage, `releases/${file.name}`);
    
    try {
      await uploadBytes(storageRef, file);
      const downloadURL = await getDownloadURL(storageRef);
      setImgSrc(downloadURL);
      setImgPreview(true);
      setUploadLabel('Replace file');
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const removeImg = () => {
    fileInputRef.current.value = '';
    setImgSrc('');
    setImgPreview(false);
    setUploadLabel('Choose file');
  };

  // Auto-fill functions
  const handleAutoArtists = () => {
    if (autoArtists) {
      setArtists2([]);
      setAutoArtists(false);
    } else {
      setArtists2(artists1);
      setAutoArtists(true);
    }
  };

  const handleAutoGenre = () => {
    if (autoGenre) {
      setGenre('');
      setAutoGenre(false);
    } else {
      setGenre(primaryGenre);
      setAutoGenre(true);
    }
  };

  const handleAutoLanguage = () => {
    if (autoLanguage) {
      setTrackLanguage('Instrumental');
      setActiveRadio1(1);
      setAutoLanguage(false);
    } else {
      setTrackLanguage(tracks[editTrackIndex-1].trackLanguage);
      setActiveRadio1(tracks[editTrackIndex-1].trackLanguage === 'Instrumental' ? 1 : 2);
      setAutoLanguage(true);
    }
  };

  // Define tab configuration
  const tabConfig = [
    { id: 1, label: 'Release Info' },
    { id: 2, label: 'Track Info' },
    { id: 4, label: 'Distribution' }
  ];

  const [showLoadingOverlay, setShowLoadingOverlay] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [showErrorModal, setShowErrorModal] = useState(false);

  const navigate = useNavigate();

  return (
    <div className='dash-section'>
      <style>{styles}</style>
      {/* Loading Overlay */}
      {showLoadingOverlay && (
        <div className="loading-overlay">
          <div className="loading-spinner">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3">Submitting release...</p>
          </div>
        </div>
      )}
      
      <h1 className='dash-title'>New Release</h1>
      <div className="row">
        <div className="col-12 mt-4">
          <div className="dash-card">
            <TabNavigation 
              tabs={tabConfig} 
              activeTab={tab} 
              onTabChange={setTab} 
            />
            
            {tab === 1 && (
              <ReleaseInfoTab
                title={title}
                setTitle={setTitle}
                artistRole={artistRole}
                setArtistRole={setArtistRole}
                artistName={artistName}
                setArtistName={setArtistName}
                artists={artists}
                artists1={artists1}
                setArtists1={setArtists1}
                removeArtist1={removeArtist1}
                primaryGenre={primaryGenre}
                setPrimaryGenre={setPrimaryGenre}
                filterPrimaryGenres={filterPrimaryGenres}
                primaryGenresList={primaryGenresList}
                secondaryGenre={secondaryGenre}
                setSecondaryGenre={setSecondaryGenre}
                filterSecondaryGenres={filterSecondaryGenres}
                secondaryGenresList={secondaryGenresList}
                originalDate={originalDate}
                setOriginalDate={setOriginalDate}
                digitalDate={digitalDate}
                setDigitalDate={setDigitalDate}
                upc={upc}
                setUpc={setUpc}
                upcDisabled={upcDisabled}
                setUpcDisabled={setUpcDisabled}
                years={years}
                copyrightYear={copyrightYear}
                setCopyrightYear={setCopyrightYear}
                copyrightLine={copyrightLine}
                setCopyrightLine={setCopyrightLine}
                publishingYear={publishingYear}
                setPublishingYear={setPublishingYear}
                publishingLine={publishingLine}
                setPublishingLine={setPublishingLine}
                label={label}
                setLabel={setLabel}
                filterLabels={filterLabels}
                labelsList={labelsList}
                activeRadio={activeRadio}
                setActiveRadio={setActiveRadio}
                checkedCountries={checkedCountries}
                setCheckedCountries={setCheckedCountries}
                countries={countries}
                handleCheckCountry={handleCheckCountry}
                imgPreview={imgPreview}
                imgSrc={imgSrc}
                uploadLabel={uploadLabel}
                fileInputRef={fileInputRef}
                checkImg={checkImg}
                removeImg={removeImg}
                handleSave={handleSave}
                isSaving={isSaving}
                setTab={setTab}
              />
            )}
            
            {tab === 2 && (
              <TrackInfoTab
                uploadText={uploadText}
                readFile={readFile}
                uploadProgress={uploadProgress}
                tracks={tracks}
                onDragEnd={onDragEnd}
                onEditTrack={handleEditTrack}
                onRemoveTrack={removeTrack}
                handleSave={handleSave}
                isSaving={isSaving}
                setTab={setTab}
              />
            )}
            
            {tab === 4 && (
              <DistributionTab
                platforms={platforms}
                handleCheck={handleCheck}
                checkAll={checkAll}
                error={error}
                handleAddRelease={handleAddRelease}
                isSubmitting={isSubmitting}
                successBtn={successBtn}
              />
            )}
          </div>
        </div>
      </div>

      {/* Modals */}
      <ArtistModal
        id="artist1Modal"
        name={name}
        setName={setName}
        website={website}
        setWebsite={setWebsite}
        facebook={facebook}
        setFacebook={setFacebook}
        twitter={twitter}
        setTwitter={setTwitter}
        instagram={instagram}
        setInstagram={setInstagram}
        youtube={youtube}
        setYoutube={setYoutube}
        spotify={spotify}
        setSpotify={setSpotify}
        apple={apple}
        setApple={setApple}
        deezer={deezer}
        setDeezer={setDeezer}
        soundCloud={soundCloud}
        setSoundCloud={setSoundCloud}
        isAddingArtist={isAddingArtist}
        handleAddArtist={() => {
          handleAddArtist();
          setArtistName(name);
        }}
      />
      
      <ArtistModal
        id="artist2Modal"
        name={name}
        setName={setName}
        website={website}
        setWebsite={setWebsite}
        facebook={facebook}
        setFacebook={setFacebook}
        twitter={twitter}
        setTwitter={setTwitter}
        instagram={instagram}
        setInstagram={setInstagram}
        youtube={youtube}
        setYoutube={setYoutube}
        spotify={spotify}
        setSpotify={setSpotify}
        apple={apple}
        setApple={setApple}
        deezer={deezer}
        setDeezer={setDeezer}
        soundCloud={soundCloud}
        setSoundCloud={setSoundCloud}
        isAddingArtist={isAddingArtist}
        handleAddArtist={handleAddArtist}
        closeTarget="#editTrackModal"
      />
      
      <EditTrackModal
        editTitle={editTitle}
        setEditTitle={setEditTitle}
        artistRole={artistRole}
        setArtistRole={setArtistRole}
        artistName={artistName}
        setArtistName={setArtistName}
        artists={artists}
        artists2={artists2}
        setArtists2={setArtists2}
        removeArtist2={removeArtist2}
        autoArtists={autoArtists}
        handleAutoArtists={handleAutoArtists}
        genre={genre}
        genresList={genresList}
        filterGenres={filterGenres}
        setGenre={setGenre}
        autoGenre={autoGenre}
        handleAutoGenre={handleAutoGenre}
        clipStart={clipStart}
        setClipStart={setClipStart}
        isrc={isrc}
        setIsrc={setIsrc}
        isrcDisabled={isrcDisabled}
        setIsrcDisabled={setIsrcDisabled}
        copyright={copyright}
        setCopyright={setCopyright}
        activeRadio1={activeRadio1}
        setActiveRadio1={setActiveRadio1}
        trackLanguage={trackLanguage}
        setTrackLanguage={setTrackLanguage}
        languages={languages}
        autoLanguage={autoLanguage}
        handleAutoLanguage={handleAutoLanguage}
        editTrackIndex={editTrackIndex}
        explicit={explicit}
        setExplicit={setExplicit}
        lyrics={lyrics}
        setLyrics={setLyrics}
        updateTrack={updateTrack}
      />

      {/* Success modals */}
      <div className="modal fade" id="successModal" tabIndex="-1" data-bs-backdrop="static" aria-labelledby="successModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body success-modal">
              <button
                type="button"
                className='success-close-btn btn-close btn'
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setShowLoadingOverlay(false);
                  navigate('/dashboard/releases');
                }}
              >
                <i className="fi fi-rr-cross"></i>
              </button>
              <i className="fi fi-rr-check-circle text-success success-icon"></i>
              <h5>Release Uploaded Successfully!</h5>
            </div>
          </div>
        </div>
      </div>

      <button data-bs-toggle="modal" data-bs-target="#draftSuccess" ref={draftSuccess} hidden></button>
      <div className="modal fade" id="draftSuccess" tabIndex="-1" data-bs-backdrop="static" aria-labelledby="draftSuccessLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body success-modal">
              <button
                type="button"
                className='success-close-btn'
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setShowLoadingOverlay(false);
                  navigate('/dashboard/releases');
                }}
              >
                <i className="fi fi-rr-cross"></i>
              </button>
              <i className="fi fi-rr-check-circle text-success success-icon"></i>
              <h5>Draft Saved Successfully!</h5>
            </div>
          </div>
        </div>
      </div>

      <button data-bs-toggle="modal" data-bs-target="#warningPopup" ref={warningPopupBtn} hidden></button>
      <div className="modal fade" id="warningPopup" tabIndex="-1" data-bs-backdrop="static" aria-labelledby="warningPopupLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body success-modal">
              <Link className='success-close-btn' to="#" data-bs-dismiss="modal">
                <i className="fi fi-rr-cross"></i>
              </Link>
              <h5>4 or more primary artists would replace the artist name to "Various Artists" on the release</h5>
              <div className="d-flex justify-content-center mt-4">
                <button className="dash-card-heading-btn cancel-btn share-btn me-2" data-bs-dismiss="modal">Cancel</button>
                <button 
                  className={`dash-card-heading-btn share-btn`} 
                  onClick={() => handleAddRelease()}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Submitting...' : 'Submit'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Error Modal */}
      <div className={`modal fade ${showErrorModal ? 'show' : ''}`} 
           style={{ display: showErrorModal ? 'block' : 'none' }} 
           tabIndex="-1" 
           data-bs-backdrop="static" 
           aria-labelledby="errorModalLabel" 
           aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body success-modal">
              <button className='success-close-btn' onClick={() => setShowErrorModal(false)}>
                <i className="fi fi-rr-cross"></i>
              </button>
              <i className="fi fi-rr-cross-circle text-danger success-icon"></i>
              <h5>Release Submission Failed</h5>
              <p className="text-danger">{submitError}</p>
            </div>
          </div>
        </div>
      </div>

      <div className={`loader-container ${loader && 'active'}`}>
        <div className="loader"></div>
      </div>
      {isAddingArtist && (
        <div className="loading-overlay">
          <div className="loading-spinner">
            <div className="spinner-border text-primary" role="status"></div>
            <p>Adding artist...</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddRelease;